import React from 'react';
import PropTypes from 'prop-types';
import Dictionary from '../../../model/Dictionary';
import ReviewFlight from '../reviewFlight/ReviewFlight';
import './ReviewFlights.css';

const ReviewFlights = ({ flights, toggleMealDetails, showMealDetails }) =>
  !flights || !flights.length ? (
    <h1>{Dictionary.flights.noFlightsAvailable}</h1>
  ) : (
    <div className='review-flights'>
      {flights.map((flight, index) => (
        <ReviewFlight
          key={`review-flight-${flight.id}-${index}`}
          flight={flight}
          toggleMealDetails={toggleMealDetails}
          showMealDetails={showMealDetails}
        />
      ))}
    </div>
  );

ReviewFlights.propTypes = {
  flights: PropTypes.arrayOf(PropTypes.object),
  toggleMealDetails: PropTypes.func,
  showMealDetails: PropTypes.string,
};

export default ReviewFlights;



// WEBPACK FOOTER //
// ./src/containers/review/reviewFlights/ReviewFlights.js